import React, { useState } from 'react';
import { Button, TwIconButton } from 'components/common';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { LuShip, LuCalendarPlus } from 'react-icons/lu';
import { FaCloudscale } from 'react-icons/fa6';
import GeneralPeriodForm from './GeneralPeriodForm';
import ReCalculatePeriodConfirm from './ReCalculatePeriodConfirm';

const OrderIntakeHeader = ({ period }) => {
  const [open, setOpen] = useState(false);
  const [recalculateOpen, setRecalculateOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div className="tw-mb-1">
        <div className="tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-gap-3">
          <div className="tw-flex tw-items-center tw-gap-3">
            <TwIconButton
              icon={FaArrowLeft}
              iconSize={14}
              variant="secondary"
              size="lg"
              onClick={() => navigate(-1)}
              title="Back"
            />

            <div className="tw-w-1.5 tw-h-10 tw-rounded-sm tw-flex-shrink-0" style={{ background: 'linear-gradient(to bottom, #0ea5e9, #6366f1)' }} />

            <div className="tw-flex tw-items-center tw-gap-2">
              <LuShip className="tw-text-blue-600" size={22} />
              <div>
                <h1 className="tw-mb-0 tw-font-bold tw-text-2xl tw-text-gray-900">Order intake/shipment</h1>
                <p className="tw-text-gray-500 tw-text-sm tw-mb-0">Track actual order intake and shipment per period by region.</p>
              </div>
            </div>
          </div>

          <div className="tw-flex tw-items-center tw-gap-2">
            <Button
              variant="secondary"
              size="md"
              leftIcon={LuCalendarPlus}
              onClick={() => setOpen(true)}
              className="tw-bg-primary-50 tw-text-primary-700 tw-border-primary-300 hover:tw-bg-primary-100"
            >
              Generate period
            </Button>
            <Button
              variant="secondary"
              size="md"
              leftIcon={FaCloudscale}
              onClick={() => setRecalculateOpen(true)}
              className="tw-bg-amber-50 tw-text-amber-700 tw-border-amber-300 hover:tw-bg-amber-100"
            >
              Recalculate period
            </Button>
          </div>
        </div>
      </div>

      {open && (
        <GeneralPeriodForm open={open} setOpen={setOpen} />
      )}

      {recalculateOpen && (
        <ReCalculatePeriodConfirm open={recalculateOpen} setOpen={setRecalculateOpen} period={period} />
      )}
    </>
  );
};

OrderIntakeHeader.propTypes = {
  period: PropTypes.object.isRequired,
};

export default OrderIntakeHeader;
